export enum EPlayerMark {
	None = "-1",
	P1 = "0",
	P2 = "X",
}
